<div class="aca-frp">
  <!-- what can go on the paper -->
  <aside class="aca-frp__list">
    <h2 class="aca-frb__panetitle">{{ 'DMS.FORMS.PAPER_FIELDS' | translate }}</h2>
    <p class="aca-frb__panehint">{{ 'DMS.FORMS.PAPER_FIELDS_HINT' | translate }}</p>
    <div class="aca-frp__group" *ngFor="let field of fields; trackBy: trackField">
      <span class="aca-frp__groupname">{{ field.label || field.key }}</span>
      <div class="aca-frp__part" *ngFor="let part of partsOf(field); trackBy: trackPart">
        <button
          type="button"
          class="aca-frp__partname"
          [class.aca-frp__partname--placed]="placesOf(field, part).length"
          (click)="show(field, part)"
          [disabled]="!placesOf(field, part).length"
        >
          <mat-icon>{{ placesOf(field, part).length ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon
          >{{ partLabel(field, part) }}
          <span class="aca-frp__count" *ngIf="placesOf(field, part).length > 1">×{{ placesOf(field, part).length }}</span>
        </button>
        <button
          type="button"
          class="aca-frp__add"
          (click)="place(field, part)"
          [attr.aria-label]="('DMS.FORMS.PAPER_PLACE' | translate) + ' ' + (field.label || field.key) + ' ' + partLabel(field, part)"
          [matTooltip]="'DMS.FORMS.PAPER_PLACE' | translate"
        >
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
    </div>
    <p class="aca-frb__hint" *ngIf="!fields.length">{{ 'DMS.FORMS.PAPER_NO_FIELDS' | translate }}</p>

    <div class="aca-frp__group">
      <span class="aca-frp__groupname">{{ 'DMS.FORMS.PAPER_MARKS' | translate }}</span>
      <div class="aca-frp__part" *ngFor="let part of markParts">
        <button
          type="button"
          class="aca-frp__partname"
          [class.aca-frp__partname--placed]="placesOf(null, part).length"
          (click)="show(null, part)"
          [disabled]="!placesOf(null, part).length"
        >
          <mat-icon>{{ placesOf(null, part).length ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon
          >{{ partLabel(null, part) }}
        </button>
        <button
          type="button"
          class="aca-frp__add"
          (click)="place(null, part)"
          [attr.aria-label]="('DMS.FORMS.PAPER_PLACE' | translate) + ' ' + partLabel(null, part)"
          [matTooltip]="'DMS.FORMS.PAPER_PLACE' | translate"
        >
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
    </div>
  </aside>

  <!-- the paper -->
  <section class="aca-frp__sheet">
    <div class="aca-frp__toolbar">
      <label class="aca-frp__target"
        >{{ 'DMS.FORMS.PAPER_TARGET' | translate }}
        <select class="aca-frb__input aca-frb__input--narrow" [(ngModel)]="targetPage">
          <option *ngFor="let page of pages; let n = index" [ngValue]="n + 1">{{ n + 1 }}</option>
        </select>
      </label>
      <span class="aca-frb__spacer"></span>
      <button type="button" class="aca-frb__icon" (click)="zoom(-0.25)" [attr.aria-label]="'DMS.FORMS.PAPER_ZOOM_OUT' | translate">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <span class="aca-frp__zoom">{{ scale() * 75 | number: '1.0-0' }}%</span>
      <button type="button" class="aca-frb__icon" (click)="zoom(0.25)" [attr.aria-label]="'DMS.FORMS.PAPER_ZOOM_IN' | translate">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button type="button" class="aca-frb__outline" (click)="testPrint.emit()">
        <mat-icon>print</mat-icon>{{ 'DMS.FORMS.PRINT_SAMPLE' | translate }}
      </button>
    </div>
    <p class="aca-frb__hint aca-frp__hint">{{ 'DMS.FORMS.PAPER_HINT' | translate }}</p>
    <p class="aca-frp__state" *ngIf="loading()">{{ 'DMS.FORMS.PAPER_LOADING' | translate }}</p>
    <p class="aca-frp__state aca-frp__state--error" *ngIf="failed()" role="alert">
      <mat-icon>error_outline</mat-icon>{{ 'DMS.FORMS.PAPER_LOAD_FAILED' | translate }}
    </p>

    <div class="aca-frp__pages" [hidden]="loading() || failed()">
      <div
        class="aca-frp__page"
        *ngFor="let page of pages; let n = index"
        [style.width.px]="page.width * scale()"
        [style.height.px]="page.height * scale()"
        [attr.aria-label]="'DMS.FORMS.PAPER_PAGE' | translate: { n: n + 1 }"
        role="group"
      >
        <canvas #pageCanvas class="aca-frp__canvas"></canvas>
        <span class="aca-frp__pageno">{{ n + 1 }}</span>
        <div
          *ngFor="let placed of placedOn(n + 1); trackBy: trackPlaced"
          class="aca-frp__box"
          [class.aca-frp__box--on]="isSelected(placed)"
          [class.aca-frp__box--mark]="!placed.field"
          [class.aca-frp__box--tick]="isTick(placed)"
          [style.left.px]="placed.place.x * scale()"
          [style.top.px]="placed.place.y * scale()"
          [style.width.px]="placed.place.w * scale()"
          [style.height.px]="placed.place.h * scale()"
          [style.font-size.px]="size(placed.place) * scale()"
          [style.background-image]="isTable(placed) ? rowLines(placed) : cellLines(placed)"
          [style.justify-content]="placed.place.align === 'center' ? 'center' : placed.place.align === 'right' ? 'flex-end' : 'flex-start'"
          tabindex="0"
          role="button"
          [attr.aria-label]="boxLabel(placed)"
          [attr.aria-pressed]="isSelected(placed)"
          [matTooltip]="boxLabel(placed)"
          (pointerdown)="startDrag($event, placed, false)"
          (keydown)="onKey($event, placed)"
        >
          <span class="aca-frp__sample">{{ sample(placed) }}</span>
          <span class="aca-frp__handle" (pointerdown)="startDrag($event, placed, true)" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </section>

  <!-- the selected box -->
  <aside class="aca-frp__props">
    <ng-container *ngIf="selected as s; else nothing">
      <h2 class="aca-frb__panetitle">
        <mat-icon>{{ s.field ? 'crop_free' : 'tag' }}</mat-icon
        >{{ s.field ? s.field.label || s.field.key : ('DMS.FORMS.PAPER_MARKS' | translate) }}
      </h2>
      <p class="aca-frp__what">{{ partLabel(s.field, s.place) }}</p>

      <label class="aca-frb__label" for="frp-page">{{ 'DMS.FORMS.PAPER_PAGE_NO' | translate }}</label>
      <select id="frp-page" class="aca-frb__input" [(ngModel)]="s.place.page" (ngModelChange)="tidy(s.place)">
        <option *ngFor="let page of pages; let n = index" [ngValue]="n + 1">{{ n + 1 }}</option>
      </select>

      <div class="aca-frp__xywh">
        <label for="frp-x">X<input id="frp-x" type="number" step="1" class="aca-frb__input" [(ngModel)]="s.place.x" (blur)="tidy(s.place)" /></label>
        <label for="frp-y">Y<input id="frp-y" type="number" step="1" class="aca-frb__input" [(ngModel)]="s.place.y" (blur)="tidy(s.place)" /></label>
        <label for="frp-w"
          >{{ 'DMS.FORMS.PAPER_W' | translate
          }}<input id="frp-w" type="number" step="1" class="aca-frb__input" [(ngModel)]="s.place.w" (blur)="tidy(s.place)"
        /></label>
        <label for="frp-h"
          >{{ 'DMS.FORMS.PAPER_H' | translate
          }}<input id="frp-h" type="number" step="1" class="aca-frb__input" [(ngModel)]="s.place.h" (blur)="tidy(s.place)"
        /></label>
      </div>
      <span class="aca-frb__hint">{{ 'DMS.FORMS.PAPER_POINTS' | translate }}</span>

      <ng-container *ngIf="takesText(s) || isTable(s)">
        <label class="aca-frb__label" for="frp-size">{{ 'DMS.FORMS.PAPER_SIZE' | translate }}</label>
        <input
          id="frp-size"
          type="number"
          class="aca-frb__input aca-frb__input--narrow"
          [min]="minSize"
          [max]="maxSize"
          step="0.5"
          [ngModel]="size(s.place)"
          (ngModelChange)="s.place.size = $event"
          (blur)="tidy(s.place)"
        />
        <span class="aca-frb__hint">{{ 'DMS.FORMS.PAPER_SIZE_HINT' | translate }}</span>
      </ng-container>

      <ng-container *ngIf="takesText(s)">
        <span class="aca-frb__label" id="frp-align-label">{{ 'DMS.FORMS.PAPER_ALIGN' | translate }}</span>
        <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frp-align-label">
          <button
            type="button"
            role="radio"
            *ngFor="let align of ['left', 'center', 'right']"
            [attr.aria-checked]="(s.place.align || 'left') === align"
            [class.aca-frb__seg--on]="(s.place.align || 'left') === align"
            (click)="s.place.align = $any(align)"
          >
            {{ 'DMS.FORMS.PAPER_ALIGN_' + align.toUpperCase() | translate }}
          </button>
        </div>
        <label class="aca-frb__label" for="frp-cells">{{ 'DMS.FORMS.PAPER_CELLS' | translate }}</label>
        <input
          id="frp-cells"
          type="number"
          min="0"
          max="40"
          class="aca-frb__input aca-frb__input--narrow"
          [(ngModel)]="s.place.cells"
          (blur)="tidy(s.place)"
        />
        <span class="aca-frb__hint">{{ 'DMS.FORMS.PAPER_CELLS_HINT' | translate }}</span>
      </ng-container>

      <ng-container *ngIf="isTable(s) && s.field as table">
        <label class="aca-frb__label" for="frp-row">{{ 'DMS.FORMS.PAPER_ROW_HEIGHT' | translate }}</label>
        <input
          id="frp-row"
          type="number"
          min="8"
          max="200"
          class="aca-frb__input aca-frb__input--narrow"
          [ngModel]="s.place.rowHeight ?? 18"
          (ngModelChange)="s.place.rowHeight = $event"
          (blur)="tidy(s.place)"
        />
        <label class="aca-frb__label" for="frp-widths">{{ 'DMS.FORMS.PAPER_WIDTHS' | translate }}</label>
        <input
          id="frp-widths"
          class="aca-frb__input"
          [ngModel]="widthsText(s.place)"
          (ngModelChange)="setWidths(table, s.place, $event)"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [placeholder]="evenWidths(table)"
        />
        <span class="aca-frb__hint">{{ 'DMS.FORMS.PAPER_WIDTHS_HINT' | translate: { columns: (table.columns ?? []).length } }}</span>
        <span class="aca-frb__hint aca-frp__fits">{{ 'DMS.FORMS.PAPER_ROWS_FIT' | translate: { rows: rowsFit(table) } }}</span>
      </ng-container>

      <div class="aca-frb__propactions">
        <button type="button" class="aca-frb__danger" (click)="remove()">
          <mat-icon>delete_outline</mat-icon>{{ 'DMS.FORMS.PAPER_REMOVE_BOX' | translate }}
        </button>
      </div>
    </ng-container>
    <ng-template #nothing>
      <h2 class="aca-frb__panetitle"><mat-icon>ads_click</mat-icon>{{ 'DMS.FORMS.PAPER_NOTHING_SELECTED' | translate }}</h2>
      <p class="aca-frb__hint">{{ 'DMS.FORMS.PAPER_KEYS_HINT' | translate }}</p>
    </ng-template>
  </aside>
</div>
